import { render, staticRenderFns } from "./DocDischargeLetter.vue?vue&type=template&id=6e2827e9"
import script from "./DocDischargeLetter.vue?vue&type=script&lang=js"
export * from "./DocDischargeLetter.vue?vue&type=script&lang=js"
import style0 from "./DocDischargeLetter.vue?vue&type=style&index=0&id=6e2827e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports